import * as React from 'react';

const ForwardIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={6} height={10}>
    <path
      fill={fillColor}
      d="M.375 9.542a.77.77 0 0 1-.177-.459.564.564 0 0 1 .177-.437l3.667-3.667L.354 1.292A.573.573 0 0 1 .198.844.64.64 0 0 1 .375.396C.514.256.663.19.823.198a.63.63 0 0 1 .427.198l4.146 4.146c.07.07.118.139.146.208.027.07.041.146.041.23 0 .082-.014.159-.041.228a.635.635 0 0 1-.146.209L1.27 9.542a.564.564 0 0 1-.438.177.77.77 0 0 1-.458-.177Z"
    />
  </svg>
);

export default ForwardIcon;
